import {
  useEffect,
  useState,
  FC,
  useCallback,
} from 'react';
import { useSelector } from 'react-redux';

import FooterComponent from 'components/Footer/Footer';
import { Store } from 'app-redux/types/storeTypes';
import { Footer } from 'src/__generated__/graphqlTypes';
import { BIO_SLUG, SCROLL_EVENT } from 'constants/constants';
import { CommonFooterInterface } from 'components/Footer/declarations';

const FooterContainer: FC<CommonFooterInterface> = ({ footer }) => {
  const [isVisibleScrollTopButton, setScrollTopButtonVisibility] = useState<boolean>(false);
  const slug = useSelector((store: Store) => store.server.page.slug);

  useEffect(() => {
    const handler = () => {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const appearationLimit = window.innerHeight * 0.2;
      setScrollTopButtonVisibility(scrollTop > appearationLimit);
    };

    const isBioPage = slug === BIO_SLUG;

    if (!isBioPage) {
      window.addEventListener(SCROLL_EVENT, handler);
    }

    return () => window.removeEventListener(SCROLL_EVENT, handler);
  }, []);

  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <FooterComponent
      footer={footer as Footer}
      scrollToTop={scrollToTop}
      isVisibleScrollTopButton={isVisibleScrollTopButton}
    />
  );
};

export default FooterContainer;
